import gql from 'graphql-tag'

export const ALL_COMMENTS = gql`
  query allComments($pageSize: Int!, $page: Int, $sector: Int, $tag: Int) {
    allComments(limit: $pageSize, page: $page, sector: $sector, tag: $tag) {
      id
      content
      status
      restrict
      createdAt: i18nDate
      userName
      question {
        id
        hierarchy
        choices {
          tags {
            id
            name
            type
          }
        }
        survey {
          id
          name
        }
        statement
        tags {
          id
          type
          name
          abbreviation
        }
      }
    }
    allCommentsCount
  }
`
export const COMMENTS_META = gql`
  query allCommentsMeta($surveyId: Int) {
    allCommentsMeta(surveyId: $surveyId)
  }
`


export const COMMENTS_PER_SERCTORS = gql `
  query SurveyForm($surveyId: Int!) {
    subtopicsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
      sector {
        b3Name
        id
      }
      tag {
        id
        name
        type
      }
    }
  }
`

export const SURVEYS = gql`
  query {
    allSurveys(order: "created_at DESC", where: { import_status: "success" }) {
      id
      name
      official
    }
  }
`
export const TOGGLE_COMMENT = gql`
  mutation ToggleMutation($commentId: Int!) {
    toggleComment(commentId: $commentId) {
      id
    }
  }
`
